export class SonyBravia {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.power = false;
        this.videoSelection = '100000001'; // HDMI 1
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'displayBlankQuery',
                regExp: /\*SEPMUT################/i,
                callback: (match) => {
                    this.socket.send(`*SAPMUT000000000000000${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /\*SCPMUT000000000000000(\d)/i,
                callback: (match) => {
                    this.displayBlank = match[1] === '1';
                    this.socket.send(`*SNPMUT000000000000000${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /\*SEPOWR################/i,
                callback: (match) => {
                    this.socket.send(`*SAPOWR000000000000000${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\*SCPOWR000000000000000(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`*SAPOWR000000000000000${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /\*SEINPT################/i,
                callback: (match) => {
                    this.socket.send(`*SAINPT0000000${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /\*SCINPT0000000(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`*SNINPT0000000${this.videoSelection}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\*SEVOLU################/i,
                callback: (match) => {
                    this.socket.send(`*SAVOLU0000000000000${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /\**SCVOLU0000000000000(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`*SAVOLU0000000000000${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\*SEAMUT################/i,
                callback: (match) => {
                    this.socket.send(`*SAAMUT000000000000000${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\*SCAMUT000000000000000(\d)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1';
                    this.socket.send(`*SAAMUT000000000000000${this.volumeMute ? '1' : '0'}`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '100000001';
    }
}
SonyBravia.emulatorType = 'socketEmulator';
SonyBravia.key = '-LrVWtqZOnvSZhCMT0sZ';
